/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { View, Text, StyleProp, ViewStyle } from "react-native";
import Icon from "react-icons-kit";
import { warning } from "react-icons-kit/fa/warning";

import { skaleWarningBackground, skaleWarningText } from "config/UpduoColors";

export default function WarningBanner({
  message,
  style,
}: {
  message: string;
  style: StyleProp<ViewStyle>;
}) {
  return (
    <View
      style={[
        style,
        {
          width: "100%",
          backgroundColor: skaleWarningBackground,
          borderRadius: 8,
          padding: 7,
        },
      ]}
    >
      <Text
        style={{ color: skaleWarningText, fontSize: 10, textAlign: "center" }}
      >
        <Icon size={10} icon={warning} style={{ marginRight: 5 }} />
        {message}
      </Text>
    </View>
  );
}
